import * as React from 'react';
import { ApolloError } from 'apollo-client';
import { Query } from 'react-apollo';

import GROUP_BY_CODE_QUERY from 'groups/queries/LoadByGroupCodeQuery.gql';
import {
  LoadGroupByCode,
  LoadGroupByCode_classes,
} from 'groups/queries/__generated__/LoadGroupByCode';

export type Props = {
  groupCode: string;
  children: (props: {
    group?: LoadGroupByCode_classes;
    loading: boolean;
    error?: ApolloError;
  }) => React.ReactNode;
};

export default function GroupByCodeFetcher(props: Props) {
  return (
    <Query<LoadGroupByCode> query={GROUP_BY_CODE_QUERY} variables={{ code: `@${props.groupCode}` }}>
      {({ loading, error, data }) => {
        const group = (data && data.classes && data.classes[0]) || undefined;
        return props.children({ group, loading, error });
      }}
    </Query>
  );
}
